<template>
	<b-container fluid>
		<b-row>
			<b-col xl="8" offset-xl="2" lg="10" offset-lg="1" class="my-5">
				<transition name="fade">
					<rb-loader v-if="!loaded" center></rb-loader>
					<b-row v-if="loaded">
						<b-col md="3" class="mb-4" v-for="s in series" :key="s.Id">
							<rb-series-thumbnail :series="s" />
						</b-col>
					</b-row>
				</transition>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
	import RbSeriesThumbnail from '../components/RbSeriesThumbnail';
	import RbLoader from '../components/RbLoader';

	export default {
		name: 'SeriesList',
		components: {RbLoader, RbSeriesThumbnail},
		metaInfo (){
			return {
				title: 'Séries'
			}
		},
		data: () => ({
			loaded: false,
			series: []
		}),
		async mounted() {
			this.series = await this.$oldApi.Series.list();

			this.loaded = true
		}
	}
</script>
<style lang="scss" scoped>

</style>